import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

const Contact = () => {
  const contactSchema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact SnapMyDesign - AI Product Photography Support",
    "description": "Get in touch with SnapMyDesign for AI-powered product photography and virtual try-on solutions. Contact our support team for demos, pricing, and technical assistance.",
    "url": "https://snapmydesign.com/contact",
    "mainEntity": {
      "@type": "LocalBusiness",
      "@id": "https://snapmydesign.com",
      "name": "SnapMyDesign",
      "description": "AI-powered product photography and virtual try-on solutions",
      "email": "manish.sahu@snapmydesign.com",
      "telephone": "+91-9005236891",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Bhopal",
        "addressRegion": "MP",
        "addressCountry": "India"
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "09:00",
        "closes": "18:00",
        "timeZone": "Asia/Kolkata"
      },
      "sameAs": [
        "https://twitter.com/snapmydesign",
        "https://linkedin.com/company/snapmydesign"
      ]
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://snapmydesign.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Contact",
          "item": "https://snapmydesign.com/contact"
        }
      ]
    }
  };

  return (
    <div>
      <div className="bg-white">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8">
          <div className="divide-y-2 divide-gray-200">
            <div className="lg:grid lg:grid-cols-3 lg:gap-8">
              <h1 className="text-3xl font-extrabold text-text-heading sm:text-4xl col-span-3 pb-10">
                Get in touch
              </h1>
              <div className="mt-8 grid grid-cols-1 gap-12 sm:grid-cols-3 sm:gap-x-8 sm:gap-y-12 lg:mt-0 col-span-3 pb-10">
                <div>
                  <h2 className="text-lg font-medium text-text-heading flex items-center">
                    <FontAwesomeIcon icon={faEnvelope} className="text-secondary-600 mr-3" />
                    Name
                  </h2>
                  <div className="mt-2 text-base text-text-description">
                    <p>
                      <a href="mailto:manish.sahu@snapmydesign.com" className="hover:text-secondary-600">
                        Manish Sahu
                      </a>
                    </p>
                  </div>
                </div>
                <div>
                  <h2 className="text-lg font-medium text-text-heading flex items-center">
                    <FontAwesomeIcon icon={faEnvelope} className="text-secondary-600 mr-3" />
                    Email
                  </h2>
                  <div className="mt-2 text-base text-text-description">
                    <p>
                      <a href="mailto:manish.sahu@snapmydesign.com" className="hover:text-secondary-600">
                        manish.sahu@snapmydesign.com
                      </a>
                    </p>
                  </div>
                </div>
                <div>
                  <h2 className="text-lg font-medium text-text-heading flex items-center">
                    <FontAwesomeIcon icon={faPhone} className="text-secondary-600 mr-3" />
                    Phone
                  </h2>
                  <div className="mt-2 text-base text-text-description">
                    <p>
                      <a href="tel:+919005236891" className="hover:text-secondary-600">
                        +91-9005236891
                      </a>
                    </p>
                    <p className="mt-1">Mon-Fri, 9am-6pm IST</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;